var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"room"}},[_c('img',{staticClass:"roomBackground",attrs:{"src":_vm.roomData[_vm.currentRoomNumber].roomimage}}),_c('GameView',{attrs:{"currentRoomData":[{room:_vm.roomData[_vm.currentRoomNumber]}]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }